var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['message-abstract-video']},[_c('div',{staticClass:"message-abstract-video-box"},[_c('img',{class:['video-snapshot'],attrs:{"src":_vm.videoUrl}}),_c('Icon',{staticClass:"video-play",attrs:{"file":_vm.playIcon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }